import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Search, PackagePlus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './TrackingSection.scss';

const TrackingSection: React.FC = () => {
  const { t } = useTranslation();
  const [trackingCode, setTrackingCode] = useState('');

  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const code = trackingCode.trim();
    if (code) {
      navigate(`/tra-cuu?q=${encodeURIComponent(code)}`);
    }
  };

  return (
    <section className="tk" aria-label={t('trangChu.tracking.sectionAria')} data-reveal data-anim="up">
      <div className="tk__container">
        <div className="tk__row" data-stagger>

          {/* Left: Search */}
          <div className="tk__search-col">
            <div className="tk__badge">
              <Search size={14} />
              {t('trangChu.tracking.badge')}
            </div>
            <h2 className="tk__heading">
              {t('trangChu.tracking.heading')} <br />
              <span className="tk__heading-accent">{t('trangChu.tracking.headingAccent')}</span>
            </h2>
            <p className="tk__subtext">{t('trangChu.tracking.subtext')}</p>
            <form className="tk__form" onSubmit={handleSearch}>
              <div className="tk__input-group">
                <input
                  type="text"
                  className="tk__input"
                  placeholder={t('trangChu.tracking.placeholder')}
                  value={trackingCode}
                  onChange={e => setTrackingCode(e.target.value)}
                  aria-label={t('trangChu.tracking.inputAria')}
                />
                <button type="submit" className="tk__submit">
                  <Search size={18} />
                  <span>{t('trangChu.tracking.searchBtn')}</span>
                </button>
              </div>
            </form>
          </div>

          {/* Right: Action cards */}
          <div className="tk__actions-col">
            <Link to="/tao-don" className="tk__action-card tk__action-card--primary">
              <div className="tk__action-icon">
                <PackagePlus size={22} />
              </div>
              <div className="tk__action-text">
                <strong>{t('trangChu.tracking.createTitle')}</strong>
                <span>{t('trangChu.tracking.createSub')}</span>
              </div>
            </Link>
          </div>

        </div>
      </div>
    </section>
  );
};

export default TrackingSection;
